import React from 'react';
import PropTypes from 'prop-types';

export default function FirstAidIcon({ size, color, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 31 27" {...rest}>
      <path
        fill={color}
        d="M29.4342987,6.68181818 L22.1428571,6.68181818 L22.1428571,1.63636364 C22.1428571,0.736363636 21.4628701,0 20.5771558,0 L10.6464199,0 C9.76070563,0 8.99134199,0.736363636 8.99134199,1.63636364 L8.99134199,6.68181818 L1.65507792,6.68181818 C0.765606061,6.68181818 0,7.4145 0,8.31818182 L0,25.3636364 C0,26.2673182 0.765606061,27 1.65507792,27 L29.4342987,27 C30.3237706,27 31,26.2673182 31,25.3636364 L31,8.31818182 C31,7.4145 30.3237706,6.68181818 29.4342987,6.68181818 Z M11.1385281,2.18181818 L19.995671,2.18181818 L19.995671,6.68181818 L11.1385281,6.68181818 L11.1385281,2.18181818 Z M21.0692641,19.0909091 L17.7142857,19.0909091 L17.7142857,22.5 L13.2857143,22.5 L13.2857143,19.0909091 L9.93073593,19.0909091 L9.93073593,14.5909091 L13.2857143,14.5909091 L13.2857143,11.1818182 L17.7142857,11.1818182 L17.7142857,14.5909091 L21.0692641,14.5909091 L21.0692641,19.0909091 Z"
      />
    </svg>
  );
}

FirstAidIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

FirstAidIcon.defaultProps = {
  size: 15,
  color: '#000',
};
